import { useRemoveTask } from '@task-manager/entities/tasks';
import { toastMutation } from '@/shared/lib';
import { ConfirmDeleteModal, Text } from '@/shared/ui';

type ConfirmDeleteDialogProps = {
  open: boolean;
  taskId: string | undefined;
  taskTitle?: string;
  onClose: () => void;
};

export const ConfirmDeleteDialog = ({
  open,
  taskId,
  taskTitle,
  onClose,
}: ConfirmDeleteDialogProps) => {
  const mutation = useRemoveTask();

  const handleDelete = () => {
    if (!taskId) return;
    mutation.mutate(
      { id: taskId },
      toastMutation({ success: 'Task deleted' }, { onSuccess: onClose })
    );
  };

  return (
    <ConfirmDeleteModal
      isPending={mutation.isPending}
      onClose={onClose}
      onConfirm={handleDelete}
      open={open}
      title="Delete task"
    >
      <Text as="p" size="sm">
        {taskTitle ? (
          <>
            Are you sure you want to delete <strong>{taskTitle}</strong>? This
            action cannot be undone.
          </>
        ) : (
          'Are you sure you want to delete this task? This action cannot be undone.'
        )}
      </Text>
    </ConfirmDeleteModal>
  );
};
